// jQuery Validation
import $ from 'jquery';
window.$ = window.jQuery = $; 
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import { normalizeTargets, scrollToElement } from '@ts/utils';

export const init = () => {
    setHTMXListeners();
    setValidatorIgnore();
}

const setValidatorIgnore = (ignore) => {
    $.validator.setDefaults({
        ignore: '.ignore',   
    });
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:beforeRequest', setHTMXFormValidator);
    document.body.addEventListener('htmx:afterSwap', applyValidator);
    document.body.addEventListener('htmx:historyRestore', applyValidator);
}

const setHTMXFormValidator = (event) => {
    const elt = event.detail?.elt;
    if (!elt || elt.tagName.toLowerCase() !== 'form') return;

    const form = elt;
    const $validator = $(form).data("validator") || $.data(form, "validator");

    if ($validator && !$(form).valid()) {
        event.preventDefault();
        form.dispatchEvent(new CustomEvent('validation:failed', { bubbles: true }));
        return false;
    }
}

const applyValidator = (evt) => {
    $.validator.unobtrusive.parse(evt.target);
    setSimpleValidation();
}

export const validateFields = (target) => {
    const [root] = normalizeTargets(target);
    if (!root) return false;

    const validator = $(root).validate();
    const fields = root.querySelectorAll('input, select, textarea');

    let isValid = true;
    let firstInvalidField = null;

    fields.forEach((field) => {
        if (!field.name) return;
        if (field.disabled) return;
        if (field.type && field.type.toLowerCase() === 'hidden') return;
        const fieldValid = validator.element(field);
        if (!fieldValid) { 
            isValid = false; 
            if (!firstInvalidField) firstInvalidField = field;
        }
    });

    if (!isValid && firstInvalidField) {
        scrollToElement(firstInvalidField);
    }

    return isValid;
}

const setSimpleValidation = () => {
    const validationFields = document.querySelectorAll('.simple-validation');
    validationFields.forEach(field => {
        field.addEventListener('input', () => {
            field.classList.remove('input-validation-error');
            const errorElement = field.nextElementSibling;
            if (errorElement && errorElement.classList.contains('field-validation-error')) {
                errorElement.textContent = '';
            }
        });
    });
}